import { render, staticRenderFns } from "./addDetails.vue?vue&type=template&id=2a85ec56&scoped=true&"
import script from "./addDetails.vue?vue&type=script&lang=js&"
export * from "./addDetails.vue?vue&type=script&lang=js&"
import style0 from "./addDetails.vue?vue&type=style&index=0&id=2a85ec56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85ec56",
  null
  
)

export default component.exports